import { useCallback, useLayoutEffect, useState } from 'react';
import type { RefCallback } from 'react';

export const useAdLinkVisibility = <T extends HTMLElement = HTMLElement>(
  externalRef?: RefCallback<T>,
) => {
  const [node, setNode] = useState<T | null>(null);
  const [isLinkVisible, setIsLinkVisible] = useState(true);

  useLayoutEffect(() => {
    if (!node) return undefined;

    const target = node.querySelector('a') ?? node;

    const checkVisibility = (width: number, height: number) => {
      setIsLinkVisible(width > 0 && height > 0);
    };

    const rect = target.getBoundingClientRect();
    checkVisibility(rect.width, rect.height);

    if (typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(([entry]) => {
      const { height, width } = entry.contentRect;
      checkVisibility(width, height);
    });

    observer.observe(target);
    return () => observer.disconnect();
  }, [node]);

  const ref = useCallback(
    (n: T | null) => {
      setNode(n);
      if (typeof externalRef === 'function') {
        externalRef(n);
      }
    },
    [externalRef],
  );

  return { ref, isLinkVisible };
};
